// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"f314e6ed","374":"f42266bf","458":"ff7b371d","606":"2eede794","617":"f314e6ed","663":"f42266bf","818":"08f7dcd2","868":"f42266bf"}[chunkId] + ".chunk.css";
};